import CompanyCreate from "./company-create";

import "./company-create.scss";


export default CompanyCreate;